import { memo } from "react";

function UnassignedPickupsMarker(props) {
  const { backgroundColor="#E5A70D", borderColor="white", size = 27 } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="23"
        height="23"
        rx="1.5"
        fill={backgroundColor}
      />
      <path
        d="M12.9609 15.2109H11.0547L10.6562 7.57812H13.3594L12.9609 15.2109ZM10.625 17.8828C10.625 17.4453 10.7422 17.1146 10.9766 16.8906C11.2109 16.6667 11.5521 16.5547 12 16.5547C12.4323 16.5547 12.7656 16.6693 13 16.8984C13.2396 17.1276 13.3594 17.4557 13.3594 17.8828C13.3594 18.2943 13.2396 18.6198 13 18.8594C12.7604 19.0938 12.4271 19.2109 12 19.2109C11.5625 19.2109 11.224 19.0964 10.9844 18.8672C10.7448 18.6328 10.625 18.3047 10.625 17.8828Z"
        fill={borderColor}
      />
      <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" stroke={borderColor} />
    </svg>
  );
}

export default memo(UnassignedPickupsMarker);
